<template>
	<div class="flash-message" :class="level" v-if="visible">
		<span class="btn-close" @click="visible = false">&times;</span>
		<p class="message">{{ text }}</p>
	</div>
</template>

<script>
	import {EventBus} from "../event-bus";

	export default {
		name: "FlashMessage",
		data() {
			return {
				level: null,
				text: null,
				visible: false,
				delay: 5,
				timeout: null
			};
		},
		created() {
			EventBus.$on("flash-message", (text, level = null) => {
				this.text = text;
				this.level = level;
				this.visible = true;

				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.visible = false;
				}, this.delay * 1000);
			});
		}
	}
</script>